export default "__VITE_ASSET__SyCnuqxA__"